import FilterConfig, {
    SearchTypes,
    Types,
} from "../../components/FilterMaker/FilterConfig";

export const DeclarationFilterConfig: FilterConfig = {
    table: "declaration",
    url: "",
    statusCountUrl: "",
    pageSize: 10,
    // dataPath: "response",
    tabKey: "status",
    statusOptions: [
        { label: "Active", value: "active", color: "success", backendValue: 1 },
        {
            label: "Pending",
            value: "pending",
            color: "warning",
            backendValue: 0,
        },
    ],

    topSectionButtons: [],
    filters: [
        {
            column: "search",
            id: "search1",
            type: Types.search,
            label: "Search",
            searchType: SearchTypes.like,
            options: [
                // { tag: "Policy ID", value: "policyId" },
                { tag: "Receiver Name", value: "receiverName" },
                { tag: "Sender Name", value: "senderName" },
                { tag: "Invoice Number", value: "invoiceNumber" },
                { tag: "Transportation Number", value: "transportationNumber" },
            ],
        },
    ],
};
